import { renderMainLeftCell, renderSectionHeader, renderRowGaps } from '../helpers';

export const renderDescriptionRow = description => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(description.label);
  rowString += renderMainLeftCell(description.data);
  rowString += `</tr>`;
  return rowString;
};

export const descriptionModule = data => {
  let descriptionString = ``;
  descriptionString += renderSectionHeader('Description');
  descriptionString += renderRowGaps();
  data.forEach(description => {
    descriptionString += renderDescriptionRow(description);
  });
  descriptionString += renderRowGaps(2);
  return descriptionString;
};
